

export default {
  name: 'block-mixin'

  props: ['block', 'index', 'config']

  created: ->
    this.block.fields = this.fields if Object.keys(this.block.fields).length <= 0
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/BlockMixin.vue